import React from "react"
import {makeStyles} from "@material-ui/core/styles"
import {Tabs, Tab} from "@material-ui/core"
import {useStore, useDispatch} from "../Store"
import {useTranslation} from "react-i18next"
import "../i18n"
import {green, blue} from "@material-ui/core/colors"
import {useTheme} from "../hooks"
import {isAmOne} from "../common"
import {useMediaQuery} from "@material-ui/core"

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: (props) => props.theme.palette.background.default,
  },
  subTabs: {
    color: (props) => (props.themeColor === `dark` ? green.A700 : blue.A700),
    display: 'inline-block',
  },
  switch: {
    marginTop: 5,
  },
  wrapper: {
    textAlign: `center`,
  }
}))

export default function SubPerspectiveBar() {
  const {t} = useTranslation()
  const {dispatch} = useDispatch()
  const {
    store: {mainType, perspective, subTabs, subPerspective, themeColor},
  } = useStore()
  const theme = useTheme(themeColor)
  const isMobile = useMediaQuery(theme.breakpoints.down(`xs`))
  const classes = useStyles({
    isMobile,
    theme,
    themeColor,
  })

  const handleChange = (event, newValue) => {
    console.log(`${subPerspective[perspective]}=>${newValue}`)
    subPerspective[perspective] = newValue
    dispatch({
      type: `SUB_PERSPECTIVE`,
      subPerspective,
    })
  }

  const tabsMenu = (
    <Tabs
      className={classes.subTabs}
      value={subPerspective[perspective]}
      onChange={handleChange}
      centered
      TabIndicatorProps={{
        style: {
          background: themeColor === `dark` ? green.A700 : blue.A700,
        },
      }}
    >
      { Object.values(subTabs).map((v, i) => { return (<Tab key={i} label={t(v)} value={v} />) }) /* i18next-extract-disable-line */ }
    </Tabs>
  )

  return <div className={classes.wrapper}>{tabsMenu}</div>
}
